import React, { FC, useEffect, useState } from "react";
import InDetailView from "../templates/InDetailView";
import ActivityFieldsView from "./ActivityFieldsView";
import TaskListView from "../NewTasks/TaskListView";
import DocumentsTabWrapper from "../projectDocument/DocumentsTabWrapper";

const ActivityInDetailView: FC<{
  id: string | number; // activity id
  activeTab: string;
}> = ({ id, activeTab }) => {
  const [tab, setTab] = useState(activeTab);
  const [refresh, setRefresh] = React.useState(false);
  return (
    <InDetailView
      body={{
        refreshOptions: {
          enabled: true,
          refresh: refresh,
          onRefresh: setRefresh,
        },
        tabOptions: {
          tab: tab,
          setTab: setTab,
          tabs: [
            {
              label: "Tasks",
              tabKey: "tasks",
              content: <TaskListView currentTab={tab} id={id} />,
            },
            {
              label: "Documents",
              tabKey: "documents",
              content: <DocumentsTabWrapper linkType="activity" />,
            },
            // {
            //   label: "Issues",
            //   tabKey: "issues",
            //   content: <></>,
            // },
            // {
            //   label: "Release Notes",
            //   tabKey: "releaseNotes",
            //   content: <></>,
            // },
            // {
            //   label: "Comments",
            //   tabKey: "comments",
            //   content: <></>,
            // },
            {
              label: "View",
              tabKey: "view",
              content: <ActivityFieldsView />,
            },
          ],
        },
      }}
    />
  );
};

export default ActivityInDetailView;
